module.exports = __webpack_public_path__ + "static/minotaur-1-28f5df4de86fa8cf7ca1ed25991566fa.png";